import { AccountObjectDto } from "../account-object/account-object.dto";
import { DtoRef } from "../../../core/store/dto/dto";

export class RestrictedAccountObjectDto extends AccountObjectDto {
    @DtoRef
    accessGroup: string;
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/restricted-account-object/restricted-account-object.dto.ts